import icon from 'vue-svgicon';

icon.register({
    'regular/login-key': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M12.818 14.517l2.545-2.545 1.752.47a1.572 1.572 0 0 0 1.924-1.924l-.47-1.752.784-.784 1.752.47a1.571 1.571 0 0 0 1.924-1.924l-.469-1.752a2.356 2.356 0 0 0-3.333-3.332l-9.741 9.741a6.283 6.283 0 1 0 3.332 3.332z" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><circle pid="1" cx="5.922" cy="18.081" r="1.571" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>`,
    },
});
